// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__Q0IWM","item":"PaymentsMobile_item__1-Ari","label":"PaymentsMobile_label__3SCM2","amount":"PaymentsMobile_amount__1Gd8T"};